import React, {Component} from 'react';
import {connect} from 'react-redux';
import DocumentsTab from "../../components/documentsTab";
import _ from 'lodash';
import {requestGetAllApplicationAttachments} from "../../actions/applicationPolicy";

class DocumentsTabHOC extends Component {

    componentWillMount(){
        let route = this.props.router.location.pathname;
        let splitedRoute = _.split(route,'/',4);
        let splitId = splitedRoute[3];
        this.props.requestGetAllApplicationAttachments(splitId);
    }

    render() {
       return (
           <DocumentsTab
                failedToGetApplicationAttachments={this.props.failedToGetApplicationAttachments}
                failedDeleteMsg={this.props.failedDeleteMsg}
                deletingDocument={this.props.deletingDocument}
                failedToGetDocumentMsg={this.props.failedToGetDocumentMsg}
                fetchingDocument={this.props.fetchingDocument}
                fetchingAllApplicationAttachments={this.props.fetchingAllApplicationAttachments}
                rowData={this.props.rowData}
                isClicked={this.props.isClicked}
                setIsClicked={this.props.setIsClicked}
            />
       )

    }
}

const mapStateToProps = (state) => {
    return {
        router: state.router,
        fetchingDocument: state.applicationPolicy.fetchingDocument,
        failedToGetDocumentMsg: state.applicationPolicy.failedToGetDocumentMsg,
        deletingDocument: state.applicationPolicy.deleting,
        failedDeleteMsg: state.applicationPolicy.failedDeleteMsg,
        failedToGetApplicationAttachments: state.newApplication.failedToGetApplicationAttachments
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        requestGetAllApplicationAttachments: (appId) => {
            dispatch(requestGetAllApplicationAttachments(appId));
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(DocumentsTabHOC);